"use client";

import type { HeaderLogoProps } from "./types/header-logo.types";

import { headerLogoStyles, headerLogoImageStyles } from "./styles/header-logo.styles";

export const HeaderLogo: React.FC<HeaderLogoProps> = (props) => {
  const { url, href, ref, alt = "", className, ...rest } = props;
  return (
    <a ref={ref} href={href} className={headerLogoStyles({ className })} {...rest}>
      <img src={url} alt={alt} className={headerLogoImageStyles()} />
    </a>
  );
};

HeaderLogo.displayName = "HeaderLogo";
